var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"roomHeader has-background-primary",style:(_vm.backgroundImage)},[_c('div',{staticClass:"exit-button mr-2",on:{"click":function($event){return _vm.GoToMenu()}}},[_c('d-icon',{attrs:{"icon":"FaArrowLeft"}})],1),_c('h5',{staticClass:"title pb-2 is-size-5"},[_vm._v(_vm._s(_vm.title ?? _vm.appTitle))])])
}
var staticRenderFns = []

export { render, staticRenderFns }